/* BatLuces Experience Director — idempotent and Shopify-section aware. */
(() => {
  const KEY = '__batlucesExperienceCleanup';
  if (typeof window[KEY] === 'function') window[KEY]();
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0, observer = null;
  const protectedText = ['inspírate con las imágenes','inspirate con las imagenes','elige tu bandada'];

  function isProtected(el) {
    if (!el || !el.closest) return true;
    if (el.closest('.mt-halloween-home__gallery-section,.mt-halloween-home__shop')) return true;
    const section = el.closest('.shopify-section');
    if (!section || section.querySelector('.mt-halloween-home')) return false;
    const text = (section.innerText || '').toLocaleLowerCase();
    return protectedText.some(label => text.includes(label));
  }
  function prepareNode(el, index) {
    if (!el || isProtected(el) || el.classList.contains('bl-experience-reveal-ready')) return;
    el.classList.add('bl-experience-reveal-ready');
    el.style.setProperty('--bl-reveal-delay', (Math.min(index % 4, 3) * 55) + 'ms');
    if (reduce.matches || !observer) el.classList.add('bl-experience-visible');
    else observer.observe(el);
  }
  function scan(scope) {
    if (!scope || !scope.querySelectorAll) return;
    const sections = [];
    if (scope.nodeType === 1 && scope.matches('.shopify-section')) sections.push(scope);
    scope.querySelectorAll('.shopify-section').forEach(el => sections.push(el));
    sections.forEach((section, index) => {
      if (isProtected(section) || section.querySelector('.mt-halloween-home')) return;
      section.querySelectorAll('h2,.rte,.multicolumn-card,.slideshow__slide').forEach((el, i) => prepareNode(el, index + i));
    });
    document.querySelectorAll('main .product-card,main .collection-card,main .card-wrapper,main .product-grid-container .card').forEach(el => {
      if (!isProtected(el)) el.classList.add('bl-experience-card');
    });
    document.querySelectorAll('main a.button,main button.button,.mt-halloween-home .mt-button').forEach(el => {
      if (!isProtected(el)) el.classList.add('bl-experience-interactive');
    });
    const home = document.querySelector('.mt-halloween-home');
    if (home) home.querySelectorAll('.mt-halloween-home__copy,.mt-halloween-home__visual,.mt-halloween-home__intro,.mt-feature,.mt-halloween-home__final,.mt-payment-strip').forEach((el, i) => {
      if (!el.closest('.mt-halloween-home__gallery-section,.mt-halloween-home__shop')) prepareNode(el, i);
    });
  }
  if ('IntersectionObserver' in window) observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('bl-experience-visible');
      observer.unobserve(entry.target);
    });
  }, {threshold:.08,rootMargin:'0px 0px -36px 0px'});
  const pageWrapper = document.querySelector('.page-wrapper');
  const pageOverflow = pageWrapper ? window.getComputedStyle(pageWrapper).overflowY : '';
  const scrollTarget = pageWrapper && /auto|scroll/.test(pageOverflow) ? pageWrapper : window;
  function update() {
    frame = 0;
    const y = scrollTarget === window ? (window.scrollY || document.documentElement.scrollTop || 0) : scrollTarget.scrollTop;
    document.body.classList.toggle('bl-scrolled', y > 12);
    const header = document.querySelector('#header-group #header-component');
    if (header) header.classList.toggle('bl-header-glass', y > 12);
    const max = scrollTarget === window ? document.documentElement.scrollHeight - window.innerHeight : scrollTarget.scrollHeight - scrollTarget.clientHeight;
    document.documentElement.style.setProperty('--bl-scroll-progress', max > 0 ? String(Math.min(1,Math.max(0,y/max))) : '0');
  }
  function schedule() { if (!frame) frame = window.requestAnimationFrame(update); }
  function sectionLoaded(event) { scan(event.target); schedule(); }
  function sectionUnloaded(event) {
    if (observer && event.target && event.target.querySelectorAll) event.target.querySelectorAll('.bl-experience-reveal-ready').forEach(el => observer.unobserve(el));
  }
  scrollTarget.addEventListener('scroll',schedule,{passive:true});
  if (scrollTarget !== window) window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',sectionLoaded);
  document.addEventListener('shopify:section:unload',sectionUnloaded);

  function initProductVariantGallery() {
    const root = document.querySelector('.product-information');
    const mediaMap = window.BatLucesVariantMedia;
    if (!root || !mediaMap || root.dataset.blVariantGalleryReady === 'true') return;
    root.dataset.blVariantGalleryReady = 'true';
    function revealVariantMedia() {
      const picker = root.querySelector('variant-picker');
      if (!picker) return;
      const selectedId = Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
        .map(input => input.getAttribute('data-variant-id'))
        .find(Boolean);
      const mediaId = selectedId && mediaMap[selectedId];
      if (!mediaId) return;
      const media = root.querySelector('.product-media[data-media-id="' + mediaId + '"]');
      const slide = media && media.closest('slideshow-slide');
      if (!slide) return;
      slide.scrollIntoView({
        behavior: reduce.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
      const image = media.querySelector('img');
      if (image) {
        image.classList.remove('bl-product-image-arrive');
        void image.offsetWidth;
        image.classList.add('bl-product-image-arrive');
      }
    }
    root.addEventListener('change', event => {
      if (event.target && event.target.matches('variant-picker input[type="radio"]')) {
        window.setTimeout(revealVariantMedia, 90);
      }
    });
    root.addEventListener('click', event => {
      if (event.target && event.target.closest('variant-picker label')) {
        window.setTimeout(revealVariantMedia, 110);
      }
    });
    window.setTimeout(revealVariantMedia, 180);
  }

  scan(document); schedule();
  window[KEY] = () => {
    scrollTarget.removeEventListener('scroll',schedule);
    if (scrollTarget !== window) window.removeEventListener('scroll',schedule);
    window.removeEventListener('resize',schedule);
    document.removeEventListener('shopify:section:load',sectionLoaded);
    document.removeEventListener('shopify:section:unload',sectionUnloaded);
    if (observer) observer.disconnect();
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0; delete window[KEY];
  };
})();
